export default [
  {
    path: '/partners',
    name: 'PagePartnersList',
    meta: { title: 'partners.listTitle', roles: ['ADMIN', 'TEAM_LEADER'], permissions: ['partners_view'] },
    component: () => import('@/pages/partners'),
  },
  {
    path: '/partners/:id/edit',
    name: 'PagePartnersEdit',
    meta: { title: 'partners.editFormTitle', roles: ['ADMIN', 'TEAM_LEADER'], permissions: ['partners_view'] },
    component: () => import('@/pages/partners/id/edit'),
  },
]
 